import { useEffect } from 'react';

type CallbackType = (payload: { dateStop: Date | null }) => void;

type UseIntervalOnVisibilityParams = {
  callback: CallbackType;
  delay: number;
  dependencies?: any[];
  enabled?: boolean;
  onReset?: () => void;
  extraOptions?: {
    onReset?: () => void;
  },
};

export function useIntervalOnVisibility({
  callback,
  delay,
  dependencies = [],
  enabled = true,
  extraOptions = {},
}: UseIntervalOnVisibilityParams) {
  const resetStates = () => {
    if (extraOptions?.onReset) extraOptions.onReset();
  };

  useEffect(() => {
    if (!enabled) return;

    let intervalId: ReturnType<typeof setInterval> | null = null;
    let dateStop: Date | null = null;

    const startInterval = () => {
      if (!intervalId) {
        intervalId = setInterval(() => callback({ dateStop }), delay);
      }
    };

    const stopInterval = () => {
      dateStop = new Date();
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        callback({ dateStop })
        startInterval();
      } else {
        stopInterval();
        resetStates();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    if (document.visibilityState === 'visible') {
      startInterval();
    }

    return () => {
      stopInterval();
      resetStates();
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [delay, enabled, ...dependencies]);
}
